import { DateTimePicker as MuiDateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import type { FC } from 'react'
import { Controller, get, useFormContext } from 'react-hook-form'
import type { DatetimePickerProps } from './types'

export const DateTimePicker: FC<DatetimePickerProps> = (props) => {
  const { name, slotProps, placeholder, shrink, format, icon, ...rest } = props
  const { control, formState } = useFormContext()

  const error = get(formState.errors, name)

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange, ref } }) => (
        <MuiDateTimePicker
          format={format}
          inputRef={ref}
          className="MuiDatepicker"
          value={value ?? null}
          onChange={onChange}
          slots={icon ? { openPickerIcon: icon } : undefined}
          slotProps={
            {
              ...slotProps,
              textField: {
                ...slotProps?.textField,
                InputLabelProps: {
                  shrink: shrink,
                },
                variant: 'filled',
                error: error,
                inputProps: {
                  placeholder: placeholder,
                },
              },
            }
            //{ textField: { variant: 'filled', error: error } }
          }
          {...rest}
        />
      )}
    />
  )
}
